import React from "react";
import PropTypes from "prop-types";
import { Select } from "theme/components/atoms/Form/Input";
import Swatches from "./Swatches";
import { useIntl, defineMessages } from "react-intl";
import FormItem from "theme/components/molecules/Form/Item";

const messages = defineMessages({
  placeholder: {
    id: "components.organisms.Configurator.OptionPicker.placeholder",
    defaultMessage: "Choose an option",
  },
  chooseColor: {
    id: "components.organisms.Configurator.OptionPicker.chooseColor",
    defaultMessage: "Choose a color",
  },
});

const OptionPicker = ({ option, selectedOption }) => {
  const intl = useIntl();

  let label = option.label;
  if (
    option.values.every(
      (value) =>
        value?.swatch?.type === "color" || value?.swatch?.type === "image"
    )
  ) {
    return (
      <FormItem label={label} required={option.required ?? true}>
        <Swatches
          id={option.id}
          name={option.id}
          options={option.values}
          value={selectedOption}
          label={intl.formatMessage(messages.chooseColor)}
        />
      </FormItem>
    );
  }

  return (
    <FormItem label={label}>
      <Select
        id={option.id}
        name={option.id}
        value={selectedOption}
        options={option.values}
        placeholder={intl.formatMessage(messages.placeholder)}
        required={option.required ?? true}
      />
    </FormItem>
  );
};

OptionPicker.propTypes = {
  appearance: PropTypes.oneOf(["default", "full"]),
};

export default OptionPicker;
